import PageContent from './components/PageContent'

const List = (props: {pageFilters: any}) => {
  const { pageFilters } = props

  return (
    <PageContent pageFilters={pageFilters} />
  )
}

export default List
